import React, { memo } from 'react';

const HORARIO_PAGO_OPTIONS = [
  { value: '', label: 'TODOS' },
  { value: '07_11', label: '7:00:00 - 11:00:00' },
  { value: '11_15', label: '11:00:01 - 15:00:00' },
  { value: '15_18', label: '15:00:01 - 18:00:00' },
  { value: '18_19', label: '18:00:01 - 19:00:00' },
  { value: '19_24', label: '19:00:01 - 23:59:59' },
];

const RentaFilters = ({ 
  filters, 
  onChange, 
  onApply, 
  onReset, 
  loading, 
  errors = {}, 
  formError = '',
  asesores = []
}) => {
  const getErrorMessage = (error) => {
    if (!error) return '';
    return Array.isArray(error) ? error[0] : error;
  };

  const fieldClass = (hasError) =>
    `w-full rounded-2xl border bg-white px-4 py-3 text-sm text-gray-900 shadow-sm transition
     ${hasError 
       ? 'border-red-400 ring-2 ring-red-200 focus:ring-red-300 focus:border-red-400'
       : 'border-gray-200 focus:ring-2 focus:ring-red-200 focus:border-red-300'}`;

  return (
    <section className="space-y-4">
      {/* Error del formulario */}
      {!!formError && (
        <div 
          className="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-red-700 text-sm" 
          role="alert" 
          aria-live="polite"
        >
          {formError}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-5 gap-4 items-start">
        {/* FECHA INICIO */}
        <div>
          <label 
            htmlFor="fecha_inicio" 
            className="block text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-2"
          >
            FECHA INICIO
          </label>
          <input
            id="fecha_inicio"
            name="fecha_inicio"
            type="date"
            value={filters.fecha_inicio}
            onChange={onChange}
            className={fieldClass(!!errors.fecha_inicio)}
            aria-invalid={!!errors.fecha_inicio}
            aria-describedby={errors.fecha_inicio ? 'fecha_inicio_error' : undefined}
          />
          <div className="h-5">
            {!!errors.fecha_inicio && (
              <p id="fecha_inicio_error" className="mt-1 text-xs text-red-600">
                {getErrorMessage(errors.fecha_inicio)}
              </p>
            )}
          </div>
        </div>

        {/* FECHA FIN */}
        <div>
          <label 
            htmlFor="fecha_fin" 
            className="block text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-2"
          >
            FECHA FIN
          </label>
          <input
            id="fecha_fin"
            name="fecha_fin"
            type="date"
            value={filters.fecha_fin}
            onChange={onChange}
            className={fieldClass(!!errors.fecha_fin)}
            aria-invalid={!!errors.fecha_fin}
            aria-describedby={errors.fecha_fin ? 'fecha_fin_error' : undefined}
          />
          <div className="h-5">
            {!!errors.fecha_fin && (
              <p id="fecha_fin_error" className="mt-1 text-xs text-red-600">
                {getErrorMessage(errors.fecha_fin)}
              </p>
            )}
          </div>
        </div>

        {/* ASESOR */}
        <div>
          <label 
            htmlFor="advisor" 
            className="block text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-2"
          >
            ASESOR
          </label>
          <select
            id="advisor"
            name="advisor"
            value={filters.advisor || ''}
            onChange={onChange}
            className={fieldClass(!!errors.advisor)}
            aria-invalid={!!errors.advisor}
            aria-describedby={errors.advisor ? 'advisor_error' : undefined}
          >
            <option value="">TODOS</option>
            {asesores.map(asesor => (
              <option key={asesor.id} value={asesor.id}>
                {asesor.nombre_completo}
              </option>
            ))}
          </select>
          <div className="h-5">
            {!!errors.advisor && (
              <p id="advisor_error" className="mt-1 text-xs text-red-600">
                {getErrorMessage(errors.advisor)}
              </p>
            )}
          </div>
        </div>

        {/* HORARIO DE PAGO */}
        <div>
          <label 
            htmlFor="horario_pago" 
            className="block text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-2"
          >
            HORARIO DE PAGO
          </label>
          <select
            id="horario_pago"
            name="horario_pago"
            value={filters.horario_pago || ''}
            onChange={onChange}
            className={fieldClass(!!errors.horario_pago)}
            aria-invalid={!!errors.horario_pago}
            aria-describedby={errors.horario_pago ? 'horario_pago_error' : undefined}
          >
            {HORARIO_PAGO_OPTIONS.map((option) => (
              <option key={option.value || 'todos'} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <div className="h-5">
            {!!errors.horario_pago && (
              <p id="horario_pago_error" className="mt-1 text-xs text-red-600">
                {getErrorMessage(errors.horario_pago)}
              </p>
            )}
          </div>
        </div>

        {/* ABONADO POR */}
        <div>
          <label 
            htmlFor="abonado_por" 
            className="block text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-2"
          >
            ABONADO POR
          </label>
          <select
            id="abonado_por"
            name="abonado_por"
            value={filters.abonado_por || ''}
            onChange={onChange}
            className={fieldClass(!!errors.abonado_por)}
            aria-invalid={!!errors.abonado_por}
            aria-describedby={errors.abonado_por ? 'abonado_por_error' : undefined}
          >
            <option value="">TODOS</option>
            <option value="CUENTA CORRIENTE">CUENTA CORRIENTE</option>
            <option value="CAJA CHICA">CAJA CHICA</option>
          </select>
          <div className="h-5">
            {!!errors.abonado_por && (
              <p id="abonado_por_error" className="mt-1 text-xs text-red-600">
                {getErrorMessage(errors.abonado_por)}
              </p>
            )}
          </div>
        </div>

        {/* Acciones */}
        <div className="flex flex-col sm:flex-row gap-3 md:col-span-5">
          <button
            type="button"
            onClick={onApply}
            disabled={loading}
            aria-busy={loading}
            className="w-full sm:flex-1 rounded-full bg-red-600 px-6 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-red-700 hover:shadow-md disabled:cursor-not-allowed disabled:bg-gray-300"
          >
            {loading ? 'Cargando…' : 'Aplicar'}
          </button>

          <button
            type="button"
            onClick={onReset}
            disabled={loading}
            className="w-full sm:flex-1 rounded-full border border-red-200 bg-white px-6 py-3 text-sm font-semibold text-red-600 shadow-sm transition hover:border-red-300 hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-70"
          >
            Limpiar
          </button>
        </div>
      </div>
    </section>
  );
};

export default memo(RentaFilters);
